import React,{useState} from 'react';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { useStateContext } from '../../contexts/ContextProvider';
import { Button} from '../../components';
import { getRegistroRetiros } from "../../services/RegistroRecolectores";
import { exportToExcel } from 'react-json-to-excel';
import { toast } from 'react-hot-toast';

const ReporteRecolectores = () => {
  const { currentColor } = useStateContext();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [procesoOn, setProcesoOn] = useState(null);
  

    const handleSubmit = async (e) =>{
        e.preventDefault(); 
        setProcesoOn("GO");
        try 
        {
            const docuData = await getRegistroRetiros(selectedDate.toISOString(),selectedDateEnd.toISOString(), "ALL" );

            exportToExcel(docuData, 'BioMap-ReporteRecolectores-');
            toast.success('Archivo Excel con Registro de Retiro de Residuos.');
            setProcesoOn(null);
        } catch (error) {
            console.error("Error al exportar Registros a Excel", error);
        }
    };

    const BarraModal = ({ processCount, onCancel }) => {
        return (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
            <div className="bg-white p-4 rounded-lg">
              <div className="grid grid-cols-1 gap-4">
                <div className="flex flex-col">
                  <p className="text-sm text-blue-900 bg-opacity-75 p-2 rounded-lg mb-2">
                    PROCESANDO ... {/*processCount*/}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4">
                <div className="flex flex-col">
                  <Button
                    color="white"
                    bgColor={currentColor}
                    text="Cancelar"
                    size="sm"
                    borderRadius="10px"
                    width="full"
                    handleClick={onCancel}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      };

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };


  const handleCancelViewer = () => {
    setProcesoOn(null);
  };

  return (

<div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">

          <div className="m-2 md:m-10 mt-20 p-2 md:p-10 bg-white rounded-3xl">

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                  <div className="flex flex-col">
                  <p className="text-xs text-gray-600"> Desde </p>
                    <SeleccionaFecha
                      selectedDate={selectedDate}
                      handleDateChange={handleDateChange}
                    />
                  </div>  
                  <div className="flex flex-col">
                  <p className="text-xs text-gray-600"> Hasta </p>
                    <SeleccionaFecha
                      selectedDate={selectedDateEnd}
                      handleDateChange={handleDateChangeEnd}
                    />
                  </div>  

                  <div className="flex flex-col">
                      <p className="text-xs text-gray-600"> &nbsp; </p>
                      <Button
                        color="white"
                        bgColor={currentColor}
                        text= "Generar"  
                        borderRadius = "10px"
                        handleClick = {handleSubmit}
                        width = "full"
                      />   
                  </div>
            </div>
            {procesoOn && <BarraModal processCount={0} onCancel={handleCancelViewer} />}
        </div>
    </div>
  );
};

export default ReporteRecolectores;